import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { images, PRIMARY_CTA_URL } from "../data/business";

export default function FinalCTA() {
    return (
        <section data-testid="final-cta-section" className="bg-paper py-20 sm:py-28 lg:py-36">
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
                    <div className="order-2 flex gap-4 sm:gap-6 lg:order-1 lg:col-span-7">
                        <Reveal className="w-1/2">
                            <img
                                src={images.portrait}
                                alt="Danielly Sousa"
                                loading="lazy"
                                className="aspect-[3/4] w-full object-cover object-top"
                            />
                        </Reveal>
                        <Reveal delay={0.15} className="mt-10 w-1/2 sm:mt-16">
                            <img
                                src={images.nailsChrome}
                                alt="Trabalho real em unhas"
                                loading="lazy"
                                className="aspect-[3/4] w-full object-cover"
                            />
                        </Reveal>
                    </div>

                    <div className="order-1 lg:order-2 lg:col-span-5">
                        <Eyebrow>Agende seu horário</Eyebrow>
                        <Reveal delay={0.1}>
                            <h2 className="mt-5 font-display text-3xl font-medium uppercase leading-[1.08] tracking-tight text-ink sm:text-4xl lg:text-5xl">
                                Suas próximas unhas
                                <br />
                                <span className="italic text-accent">podem começar aqui.</span>
                            </h2>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <p className="mt-5 max-w-md text-sm leading-relaxed text-ink-soft sm:text-base">
                                Fale diretamente com o Studio e garanta o seu horário.
                            </p>
                        </Reveal>
                        <Reveal delay={0.3}>
                            <a
                                href={PRIMARY_CTA_URL}
                                data-testid="final-cta-whatsapp"
                                className="group mt-9 inline-flex items-center gap-3 bg-accent px-8 py-5 font-mono text-[11px] uppercase tracking-[0.2em] text-paper transition-colors duration-300 hover:bg-ink"
                            >
                                Agendar meu horário
                                <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
                            </a>
                            <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.2em] text-ink-soft/70">
                                Atendimento direto e sem complicação.
                            </p>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
